import {
    GET_AGENT,
    GET_ALL_AGENTS,
    GET_AGENT_REQUEST,
    CREATE_AGENT,
    UPDATE_AGENT,
    DELETE_AGENT,
    CLEAR_AGENT,
    AGENT_ERROR,
    AGENT_LOADING
} from '../actions/types';

const initialState = {
    agents: [],
    agent: null,
    loading: false,
    error: null
};

export default function agentReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case AGENT_LOADING:
        case GET_AGENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_AGENTS:
            return {
                ...state,
                agents: payload,
                loading: false,
                error: null
            };

        case GET_AGENT:
            return {
                ...state,
                agent: payload,
                loading: false,
                error: null
            };

        case CREATE_AGENT:
            return {
                ...state,
                agents: [payload, ...state.agents],
                agent: payload,
                loading: false,
                error: null
            };

        case UPDATE_AGENT:
            return {
                ...state,
                agents: state.agents.map(agent =>
                    agent._id === payload._id ? payload : agent
                ),
                agent: payload,
                loading: false,
                error: null
            };

        case DELETE_AGENT:
            return {
                ...state,
                agents: state.agents.filter(agent => agent._id !== payload),
                loading: false,
                error: null
            };

        case CLEAR_AGENT:
            return {
                ...state,
                agent: null,
                error: null
            };

        case AGENT_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };

        default:
            return state;
    }
}
